import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import HizmetDetay from '../../components/HizmetDetay';
import kombiResmi from '../../assets/kombi-teknik-servis-resim.webp';
import AOS from 'aos';
import 'aos/dist/aos.css';

function KombiServisi() {
  // --- AOS VE DİNAMİK BAŞLIK ---
  useEffect(() => {
    // Sayfa başlığını zorla çakıyoruz
    document.title = "Ankara Kombi Teknik Servis | 7/24 Tamir & Bakım";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // --- GOOGLE İÇİN ÖZEL SERVİS ŞEMASI (JSON-LD) ---
  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Kombi Teknik Servis",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881"
    },
    "areaServed": {
      "@type": "City",
      "name": "Ankara"
    },
    "description": "Ankara genelinde 7/24 garantili kombi tamiri, bakımı ve petek temizliği hizmeti. Tüm markalarda orijinal yedek parça desteği.",
    "offers": {
      "@type": "Offer",
      "availability": "https://schema.org/InStock",
      "priceCurrency": "TRY"
    }
  };

  return (
    <>
      <Helmet>
        <title>Ankara Kombi Teknik Servis | 7/24 Tamir & Bakım</title>
        <meta name="description" content="Ankara'da Vaillant, Bosch, Demirdöküm, Buderus ve tüm markalar için 7/24 garantili kombi teknik servis. Hemen arayın, 30 dakikada kapınıza gelelim." />
        {/* JSON-LD Şeması */}
        <script type="application/ld+json">
          {JSON.stringify(serviceSchema)}
        </script>
      </Helmet>

      <div data-aos="fade-up">
        <HizmetDetay 
          icon="🔥"
          baslik="Ankara Kombi Teknik Servis"
          stat1="Kışa Hazır"
          stat2="Aynı Gün"
          resim={kombiResmi}
          aciklama="Kombiniz ısıtmıyor mu, su mu akıtıyor veya petekleriniz mi soğuk? Kışın ortasında mağdur olmamanız için Ankara'nın tüm ilçelerine yayılan gezici ekiplerimizle anında müdahale ediyoruz."
          seoMetni={(
            <>
              {/* SEO KART 1: GENEL HİZMET VE ANKARA */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="100">
                <h4>Ankara Geneli 7/24 Kesintisiz Kombi Desteği</h4>
                <p>
                  Kış aylarında mağdur olmamanız için <strong>kombi teknik servis</strong> alanında uzman kadromuzla <strong>7/24 ankara kombi servisi</strong> sunuyoruz. Acil durumlarda <strong>ankara kombi servisi 1 km içinde</strong> kapınızda olacak şekilde hazır bekliyoruz. <strong>ankara kombi servisi</strong> ağımızla <strong>ankara kombi</strong> sistemlerinizdeki her türlü arızada yanınızdayız. Profesyonel <strong>ankara kombi tamiri</strong> ve <strong>ankara kombi bakım</strong> işlemlerinizi şeffaf <strong>ankara kombi fiyatları</strong> ve bütçe dostu <strong>ankara kombi bakım fiyatları</strong> garantisiyle gerçekleştiriyoruz.
                </p>
              </div>

              {/* SEO KART 2: ALMAN DEVLERİ */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="200">
                <h4>Alman Teknolojisi Kombilerde Yetkili Servis Hassasiyeti</h4>
                <p>
                  <strong>bosch kombi teknik servis</strong> ve <strong>buderus kombi teknik servis</strong> standartlarında hizmet veriyoruz. <strong>bosch kombi ankara servisi</strong> güvencemizle; <strong>bosch kombi keçiören teknik servis</strong>, <strong>bosch kombi çankaya yetkili servis</strong> ve <strong>bosch kombi eryaman teknik servis</strong> noktalarımız aktiftir. <strong>buderus ankara kombi servisi</strong> arayışlarınızda <strong>buderus mamak kombi tamircisi</strong>, <strong>buderus yenimahalle kombi servisi</strong> ve <strong>buderus sincan kombi tamiri</strong> yapıyoruz. Ayrıca <strong>vaillant ankara kombi servisi</strong> ekiplerimizle <strong>vaillant altındağ kombi teknik servis</strong>, <strong>vaillant pursaklar kombi tamircisi</strong> sağlıyor; <strong>viessmann ankara kombi servisi</strong> kalitemizle <strong>viessmann çankaya kombi yetkili servis</strong> ve <strong>viessmann eryaman kombi teknik servis</strong> işlemlerinizi garantiliyoruz.
                </p>
              </div>

              {/* SEO KART 3: YERLİ ÜRETİM */}
              <div className="editorial-card" data-aos="fade-right" data-aos-delay="300">
                <h4>Yerli ve Popüler Markalarda Kesin Çözüm</h4>
                <p>
                  Türkiye'nin en çok tercih edilen markalarında kesin çözüm sunuyoruz. <strong>demirdöküm ankara kombi servisi</strong> birimimizle; <strong>demirdöküm keçiören kombi teknik servis</strong>, <strong>demirdöküm mamak kombi tamircisi</strong>, <strong>demirdöküm çankaya kombi yetkili servis</strong> ve <strong>demirdöküm sincan kombi bakımı</strong> operasyonlarını yönetiyoruz. <strong>baymak ankara kombi servisi</strong> arayanlar için <strong>baymak yenimahalle kombi servisi</strong>, <strong>baymak eryaman kombi teknik servis</strong> ve <strong>baymak sincan kombi tamiri</strong> desteği mevcuttur. Yerli üretim güvencesiyle <strong>eca ankara kombi servisi</strong> ağımız; <strong>eca keçiören kombi teknik servis</strong>, <strong>eca çankaya kombi yetkili servis</strong> ve <strong>eca eryaman kombi teknik servis</strong> hizmetlerini orijinal yedek parçayla sunar.
                </p>
              </div>

              {/* SEO KART 4: GLOBAL VE DİĞER MARKALAR */}
              <div className="editorial-card" data-aos="fade-left" data-aos-delay="400">
                <h4>Geniş Kapsamlı Küresel Marka Onarım Ağı</h4>
                <p>
                  Geniş marka ağımızla her cihaza hakimiz. <strong>alarko carrier ankara kombi servisi</strong> bünyesinde <strong>alarko keçiören kombi teknik servis</strong> ve <strong>alarko yenimahalle kombi servisi</strong> olarak çalışıyoruz. <strong>protherm ankara kombi servisi</strong>, <strong>protherm çankaya kombi yetkili servis</strong> ve <strong>protherm sincan kombi tamiri</strong> sağlıyoruz. <strong>ariston ankara kombi servisi</strong> ve <strong>ferroli ankara kombi servisi</strong> noktalarında aktifiz. İklimlendirme ustalarımız <strong>daikin ankara kombi servisi</strong>, <strong>daikin keçiören kombi teknik servis</strong>, <strong>immergas ankara kombi servisi</strong>, <strong>warmhaus ankara kombi servisi</strong>, <strong>termoteknik ankara kombi servisi</strong>, <strong>airfel ankara kombi servisi</strong>, <strong>remeha ankara kombi servisi</strong> ve <strong>wolf ankara kombi servisi</strong> cihazlarında %100 orijinal parça güvencesiyle 1 yıl garantili periyodik bakım yapar.
                </p>
              </div>
            </>
          )}
        />
      </div>
    </>
  );
}

export default KombiServisi;